var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectFilesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.238 10.3176V17.0312C13.238 17.9805 12.4939 18.75 11.5603 18.75H4.29272C3.35718 18.75 2.61304 17.9805 2.61304 17.0312V6.71875C2.6157 6.26373 2.79764 5.82811 3.11939 5.50636C3.44114 5.1846 3.87677 5.00267 4.33179 5H8.00835C8.13561 5.00019 8.26156 5.02571 8.37885 5.07507C8.49615 5.12443 8.60245 5.19664 8.69155 5.2875L12.9552 9.62344C13.1366 9.80894 13.2382 10.0581 13.238 10.3176V10.3176Z",
    stroke: "#3913D2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92554 5V9.21875C7.92898 9.50776 8.04533 9.78396 8.2497 9.98834C8.45408 10.1927 8.73028 10.3091 9.01929 10.3125H13.238",
    stroke: "#3913D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98804 5V2.96875C6.9907 2.51373 7.17264 2.07811 7.49439 1.75636C7.81614 1.4346 8.25177 1.25267 8.70679 1.25H12.3787C12.5066 1.25018 12.6333 1.27567 12.7513 1.32501C12.8694 1.37436 12.9765 1.44657 13.0666 1.5375L17.3302 5.87344C17.5115 6.05696 17.6131 6.30454 17.613 6.5625V13.2812C17.613 14.2305 16.8689 15 15.9353 15H13.5505",
    stroke: "#3913D2",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3005 1.25V5.46875C12.304 5.75776 12.4203 6.03396 12.6247 6.23834C12.8291 6.44271 13.1053 6.55905 13.3943 6.5625H17.613",
    stroke: "#3913D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFilesIcon);
export default __webpack_public_path__ + "static/media/selectFilesIcon.b5e27ac0.svg";
export { ForwardRef as ReactComponent };